import $ from 'jquery'
import slick from 'slick-carousel'
import velocity from 'velocity-animate'
import page from 'page.js'
import Masonry from 'masonry-layout'
import disableScroll from 'disable-scroll'
import pace from 'pace-js'
import vjs from 'video.js'

pace.paceOptions = {
	ajax: false, 
	elements: false,
	document: false,
	eventLag: false,
	restartOnPushState: false,
	restartOnRequestAfter: false
}


var jQuery = $

if ((navigator.language !== 'nl' || navigator.language !== 'nl-be') && window.localStorage.hasChanged !== '1') {
	window.localStorage.hasChanged = 1
	$('.language a')[0].click()
}

//import Hammer from 'hammerjs'

var imagesLoaded = require('imagesLoaded')
imagesLoaded.makeJQueryPlugin( $ )


window.page = page

var $win
    , $body
    , userData = navigator.userAgent
    , isMoblie = /iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle/i.test(userData)
    , isPad = /iPad/i.test(userData)
    , isPhone = /iP(hone|od)|Android|BlackBerry|IEMobile|Kindle/i.test(userData)

    // State
    , isHome = false
    , isInit = true
    , isAnimate = false
    , isAjax = false
	, isChangeHash  = false
	, isProjectPage = false
	, hasDisableScroll = false
	, isDisableScroll = false
	, msnry
	, currentUrl = ''
	, $sections
	, $title
	, $fixedTitle
	, $yearnavi
	, sections
	, sectionIndex
    
    , cache = {}
    , $wrap
    , $container
    , $content
    , $slider


    // Events
    var _es = $({})

    $.subscribe = function() {
        _es.on.apply(_es, arguments)
    }

    $.unsubscribe = function() {
        _es.off.apply(_es, arguments)
    }

    $.publish = function() {
        _es.trigger.apply(_es, arguments)
    }



    // Router
    window.init = {
        ctx: function(ctx, next) {
            ctx.data = {}
            ctx.partials = {}
            next()
        }
    }

    window.render = {
        pages: function(ctx, next) {
            if (isChangeHash) return;
            
            if (!isInit) {
                if (!isAjax) {
                    isAjax = true
                    var url = ctx.canonicalPath + '?ajax=true'
                    if (ctx.canonicalPath.indexOf('?') !== -1) {
                        url = ctx.canonicalPath + '&ajax=true'
                    }

                    get(url, function(html) {
                        update(html, 'ajax')
                        isAjax = false

                        if (typeof done === 'function') done(ctx.data.index)
                    })
                }

            } else {
                update(null, 'init')
            }

            isInit = false
        }
    }

    window.done = null

    // Functions
    function get(url, cb) {
        if (cache[url] && url !== '/ow/?ajax=true' && url !== '/?ajax=true') {
			var h = cache[url].replace(/&profile_id=/g, '&t='+ Math.random() +'&profile_id=');
			
			//console.log(h)
			return cb(h)
		}

        $.ajax({
            url: url,
            success: function(data) {
                cache[url] = data;
                cb(data)
            },
            error: function(jqXHR, textStatus, errorThrown) {
                console.log(jqXHR, textStatus, errorThrown);
            },
            dataType: 'text'
        })
    }

    function update(html, type) {
        if (type === 'init') {
            // Init
            $(document).ready(init)
            
        } else {
            // Ajax
            $content = $(html)
            updateClass()
            hanadle($content, true)
        }
    }

    function updateClass() {
        if (typeof $content.data('title') !== 'undefined') {
            $body.attr('class', $content.data('bodyClass'))
			document.title = $content.data('title')
			currentUrl = $content.data('currentUrl')
        }
    }

    function hanadle($e) {
        if (isAjax) {
            velocity($container, 'fadeOut', 50, function() {
                $('body,html').scrollTop(0)
                $container.html($e).css('opacity', 0).show()
				run()
				
				if (hasDisableScroll) {
					disableScroll.off()
					hasDisableScroll = false
				}

                velocity($container, 'fadeIn', 50)
            })


        } else {
            run()

            if ('scrollRestoration' in history) {
                history.scrollRestoration = 'manual'
            }
        }
	}
	
	function updateInfo($el) {
		var decoded = $('<textarea/>').html($el.data('text')).text()

		var bgColor = ''
		var bgSize = ''
		var html = decoded
		if ($el.data('link')) {
			html = '<a href="'+$el.data('link')+'">' + decoded + '</a>'
		}

		if ($el.data('bgColor') && $el.data('bgColor') !== '') {
			bgColor = 'bg-' + $el.data('bgColor') 
		}
		
		if ($el.data('bgSize') && $el.data('bgSize') !== '') {
			if ($el.data('bgSize') == 1) {
				bgSize = 'bg-full-height'
			} else if ($el.data('bgSize') == 2) {
				bgSize = 'bg-full-bleed'
			}
			
		}

		$('#js-info').html(html)
		$('#js-info')[0].classList = 'info ' + $el.data('fontColor') + ' ' + bgColor + ' ' + bgSize
	}



    function slider() {
		var isFade = true
		var speed = 100

		if (isMoblie) {
			isFade = false
			speed = 300
		}

		if ($('.js-video-item').length !== 0 && !isMoblie) {
			$('.js-video-item').each(function() {

				var $video = $(this)
				var isDisable = $video.hasClass('js-disable-autoplay')
				if (isMoblie) $video.addClass('is-mobile-video')

				
				
				vjs($video[0]).ready(function(){
					if (!isDisable) this.play()

					var $box = $video.parents('.embed-video').find('.vjs-loading-spinner')
					var $btn = $video.parents('.embed-video').find('.vjs-play-control')
				})
			})
		}
		
        if ($('#js-slider').length !== 0) {
			var isAutoplay = isMoblie

            $('#js-slider').on('init', function(event, slick){
				if (isHome) {
					updateInfo($(this).find('.slick-active .item'))
					
					if ($(this).find('.slick-active .item').hasClass('arrow-2')) {
						$('#js-slider').addClass('red-arrow')
					}

					if ($(this).find('.slick-active .item').hasClass('video')) {
						$(this).find('.slick-active video')[0].play()
						// $(this).find('.slick-active iframe').attr('src', $(this).find('.slick-active .item').data('video') + '?autoplay=1')
					}
				}

			})
			
            $('#js-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
				if (isHome) {
					updateInfo($(this).find('[data-slick-index="'+ nextSlide +'"]  .item'))

					if ($(this).find('.slick-active .item').hasClass('video')) {
						$(this).find('.slick-active video')[0].pause()
						// $(this).find('.slick-active iframe').attr('src', $(this).find('.slick-active .item').data('video'))
					}

					
				}
            })

            $('#js-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
				if (isHome) {
					if ($(this).find('.slick-active .item').hasClass('arrow-2')) {
						$('#js-slider').addClass('red-arrow')
					} else {
						$('#js-slider').removeClass('red-arrow')
					}

					if ($(this).find('.slick-active .item').hasClass('video')) {
						$(this).find('.slick-active video')[0].play()
						// $(this).find('.slick-active iframe').attr('src', $(this).find('.slick-active .item').data('video') + '?autoplay=1')
					}

					//updateInfo($(this).find('.slick-active .item'))
				}

            })


            $('#js-slider').slick({
				// infinite: false,
				autoplay: isAutoplay,
                adaptiveHeight: true,
                slidesToShow: 1,
				slidesToScroll: 1,
				speed: speed,
				
				cssEase: 'ease',
                fade: isFade
            })


		}
		
		if ($('.js-slider').length !== 0) {
			$('.js-slider').each(function() {
				var $this = $(this)
				var $current = $this.parents('.publication-image,.item').find('.current')
				var isAutoplay = $this.hasClass('js-autoplay')

				if ($current.length !== 0) {
					$this.on('afterChange', function(event, slick, currentSlide, nextSlide){
						$this.parents('.item').find('.js-captions').html($this.find('.slick-active img').attr('alt'))
						if (!isAutoplay) $current.html(currentSlide + 1)
						/*if (isAutoplay) {
							if (currentSlide === 0) $this.slick('slickPause')
						} else {
							$current.html(currentSlide + 1)
						}*/
					})
				}

				if (!isAutoplay) {
					isFade = false
					speed = 300
				} else {
					isFade = true
					speed = 0
				}



				$this.slick({
					adaptiveHeight: false,
					autoplay: isAutoplay,
					slidesToShow: 1,
					slidesToScroll: 1,
					autoplaySpeed: 1000,
					speed: speed,
					pauseOnHover: false,
					fade: isFade
				})
			})
		}

        if ($('#js-grid').length !== 0) {
            var grid = document.querySelector('#js-grid')

            imagesLoaded( grid, function() {
                
                msnry = new Masonry( grid, {
                    itemSelector: '.js-grid-item'
					, columnWidth: 1
					, transitionDuration: 0
				})
				
				setTimeout(function() {
					$('.js-year-item').each(function() {
						$(this).css('top', $(this).next('.news-item').css('top'))
					})
				}, 500)
            })
			/*
            $('.js-desc').each(function() {
                $(this).dotdotdot({
                    height: $(this).height()
                })
			})
			*/
            



        }

	}
	
	function scrollTo($e, offset) {
		var o = 0
		
		if ($e.length !== 0) {
			o = $e.offset().top
		

			$('body,html').animate({
				scrollTop: o - offset
			}, 300)
		}
	}


	function checkVisible(elm, threshold, mode) {
		threshold = threshold || 0
		mode = mode || 'visible'

		var rect = elm.getBoundingClientRect()
		var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight)
		var above = rect.bottom - threshold < 0
		var below = rect.top - viewHeight + threshold >= 0
		return mode === 'above' ? above : (mode === 'below' ? below : !above && !below)
	}


	function scroll() {

		var scrollY = (window.scrollY || window.pageYOffset || document.documentElement.scrollTop)

		// console.log(scrollY)
		if (isMoblie && isProjectPage) {
			//isProjectPage = $body.hasClass('page-project')

			if ((scrollY + (window.innerHeight*.21)) > $title.offset().top){
				$fixedTitle.addClass('fixed-end')
			} else {
				$fixedTitle.removeClass('fixed-end')
			}

			//$title = $('#js-title')
			//$fixedTitle = $('#js-fixed-title')
		}
		
		if ($sections.length !== 0 && !isDisableScroll) {
			var isnpne = 0;
			$sections.each(function() {
				isnpne ++;
				if (checkVisible($(this)[0], 100, 'visible')) {
					sectionIndex = ($(this).data('year'))
					$('#container .current').removeClass('current')
					$('#js-current-' + sectionIndex).addClass('current')




					//$body.addClass('show-sub-navi');
					//$yearnavi.find('.active').removeClass('active');
					//$navi.find('.js-go-to').eq(sectionIndex).addClass('active');
					return false;
				}

				if (isnpne === sections) {
					// console.log('none');
					//$navi.find('.active').removeClass('active');
					//$body.removeClass('show-sub-navi');
				}
			});
		}
	}


    function run() {


		isHome = $body.hasClass('page-home')
		isProjectPage = $body.hasClass('page-project')
		/*
		if (isProjectPage && isPhone) {
			$('.item img').each(function() {
				var small = $(this).data('small')
				if (small) $(this).attr('src', small)
			})
		}
		*/

		$title = $('#js-title')
		$fixedTitle = $('#js-fixed-title')

		$sections = $('.years-item')
		$yearnavi = $('#js-year, #js-years')
		sections = $sections.length

		


		slider()
	}
	
	var hasFs = false
	var hideTimer

    function bindEvents() {
		var hasShowText = false
        scroll()
		$win.on('scroll', scroll)

		$body
			.on('click', 'a', function(e) {
				var u = $(this).attr('href')
 
				if (
					u.indexOf('.pdf') !== -1 ||
					u.indexOf('.zip') !== -1 ||
					u.indexOf('.rar') !== -1 ||
					u.indexOf('.jpg') !== -1 ||
					u.indexOf('.png') !== -1 ||
					u.indexOf('.gif') !== -1 ||
					u.indexOf('.psd') !== -1 ||
					u.indexOf('.ai') !== -1 
			
				) {
					

					isChangeHash = true
					
					var win = window.open(u, '_blank')
					win.focus()


					setTimeout(() => {
						isChangeHash = false
					}, 500)



					return false
				}



		   })

			.on('click', '#js-main-navi .logo a', function() {

				if (isPhone) {
					if ($body.hasClass('show-navi')) {
						$body.removeClass('show-navi')
					} else {
						$body.addClass('show-navi')
					}
	
					return false
				}

			})
			.on('click', '.language a', function(e) {
				e.preventDefault()
				if (typeof currentUrl === 'undefined' || currentUrl === '') {
					window.location.href = $(this).attr('href')
				} else {
					window.location.href = currentUrl
				}
				isChangeHash = true
				
				return false
            })


		   /*.on('click', '#js-back', function() {
			   window.history.back()

		   })*/
		   .on('touchstart', '.js-show-text', function() {
			   if ($(this).hasClass('show')) {
					$(this).text('Read more').removeClass('show').parents('.publication-image').next('.publication-text').removeClass('show')
			   } else {
					$(this).text('Read less').addClass('show').parents('.publication-image').next('.publication-text').addClass('show')
			   }
			})
			.on('click', '.js-grid-item .click', function() {
				if (isPhone && !hasShowText) {
					hasShowText = true
					$(this).parents('.js-grid-item').addClass('hover') 
					disableScroll.on()
					hasDisableScroll = true

					setTimeout(function() {
						hasShowText = false
					}, 500)

				}
			 })
			 .on('touchstart', '.js-grid-item .text a', function() {
				hasShowText = true

				setTimeout(function() {
					hasShowText = false
				}, 500)
			 })
			 .on('touchstart', '.js-grid-item .text', function() {
				if (isPhone && !hasShowText) {
					hasShowText = true
					$('.js-grid-item.hover').removeClass('hover') 
					disableScroll.off()
					hasDisableScroll = false

					setTimeout(function() {
						hasShowText = false
					}, 500)
				}
			 })
			.on('mouseenter click', '.vjs-play-control', function(e){
				var $e = $(this)

				setTimeout(() => {
					$e.attr('title', '')
				}, 100)

				e.preventDefault()
			})
			.on('click', '.vjs-fullscreen-control', function(e){
				var box = $(this).parents('.image')

				box.addClass('hide')
				hasFs = true
				setTimeout(() => {
					hasFs = false
				}, 1500)

			})

			.on('mousemove', '.project-content .image', function(e){
				var $el = $(this)
				if (!hasFs) $el.removeClass('hide')

				if (hideTimer) clearTimeout(hideTimer)
				hideTimer = setTimeout(() => {
					$el.addClass('hide')
				}, 2000)

				
			})

		   .on('click touchstart', '.js-share', function() {
				var text = '', url = ''
				text = document.title

					
				if ($(this).data('text') !== '') {
					text = $(this).data('text');
				} else  {
					text = document.title
					text = $.trim(text);
				}
								
				if ($(this).data('link') !== '') {
					url = $(this).data('link');
				} else  {
					url = window.location.href
				}



				text = encodeURIComponent(text.substr(0, 100))
				
				if ($(this).hasClass('twitter')) {
					window.open(
						'https://twitter.com/intent/tweet?url=&text=' + text + ' ' + url + ' via @officewinhov&original_referer=' + url,
						'share_page',
						'width=600, height=500, top=' + (screen.height - 500) / 2 + ', left=' + (screen.width - 600) / 2 + ', status=no, toolbar=no, menubar=no, scrollbars=yes'
					)
				}

				else if ($(this).hasClass('linkedin')) {
					window.open(
						'https://www.linkedin.com/shareArticle?mini=true&url=' + url + '&title=' + text,
						'share_page',
						'width=600, height=500, top=' + (screen.height - 500) / 2 + ', left=' + (screen.width - 600) / 2 + ', status=no, toolbar=no, menubar=no, scrollbars=yes'
					)
				}

				/*
				
				if ($(this).hasClass('fb')) {
					window.open(
						'http://www.facebook.com/sharer/sharer.php?u=' + url,
						'share_page',
						'width=600, height=500, top=' + (screen.height - 500) / 2 + ', left=' + (screen.width - 600) / 2 + ', status=no, toolbar=no, menubar=no, scrollbars=yes'
					);
				}

				else if($(this).hasClass('tw')) {
					window.open(
						'https://twitter.com/intent/tweet?url=&text=' + text + ' ' + url + ' via @bao_london&original_referer=' + url,
						'share_page',
						'width=600, height=500, top=' + (screen.height - 500) / 2 + ', left=' + (screen.width - 600) / 2 + ', status=no, toolbar=no, menubar=no, scrollbars=yes'
					);
				}
				*/
				
				return false;
			})
			.on('submit', '#js-search-form', function() {
				$.ajax({
					type: 'POST',
					url: window.location.href,
					data: {
						search_query: $('#js-search-query').val()
					},
					success: function(data) {
						isAjax = true
						update(data, 'ajax')

						setTimeout(() => {
							isAjax = false
						}, 1000)
					},
					error: function(jqXHR, textStatus, errorThrown) {
						console.log(jqXHR, textStatus, errorThrown);
					},
					dataType: 'text'
				})

				return false
			})

            .on('click', '.js-show-slider', function() {
				$('.run-slider').each(function() {
					$(this).removeClass('run-slider')
					$(this).find('.js-slider').slick('setPosition')
				})

				var $el = $(this).parents('.publication-image')
								
                if (!$el.hasClass('run-slider')) {
					$el.addClass('run-slider')
					
					$el.find('.js-slider').slick('setPosition')
                }

                return false
			})
            .on('click', '.js-image', function() {
				disableScroll.on()
				hasDisableScroll = true
				$('#js-big-image').html('<img src="'+ $(this).data('url') +'">').addClass('show')
				

                return false
			})
            .on('click', '#js-big-image', function() {
				disableScroll.off()
				hasDisableScroll = false
				$('#js-big-image').removeClass('show')
				

                return false
			})
            .on('click', '#js-hamburger', function() {
                if ($body.hasClass('show-navi')) {
                    $body.removeClass('show-navi')
                } else {
                    $body.addClass('show-navi')
                }

                return false
			})

			.on('click', '#js-year span', function() {
				$('#js-year .current').removeClass('current') 
				$(this).addClass('current')
				isDisableScroll = true

				setTimeout(function() {
					isDisableScroll = false
				}, 1200)

				// scrollTo($('#js-year-' + $(this).attr('data-year')), $('#js-year').offset().top - $body[0].scrollTop)
				var $e = $('#js-year-' + $(this).attr('data-year'))
	
				if ($e.length !== 0) {
					var o = $e.offset().top

				
		
					$('body,html').animate({
						scrollTop: o - 160
					}, 300)
				}
                return false
            })
			.on('click touchstart', '.js-goto', function() {

				scrollTo($($(this).data('ele')), 52)

                return false
            })

            .on('click', '#js-years span', function() {
				if (!$(this).hasClass('current')) {
                    $('#js-years .current').removeClass('current')
					$(this).addClass('current')

					isDisableScroll = true
	
					setTimeout(function() {
						isDisableScroll = false
					}, 500)
					var $e = $('#js-year-item-' + $(this).attr('data-year'))
		
					if ($e.length !== 0) {
						var o = $e.offset().top

					
			
						$('body,html').animate({
							scrollTop: o - 130
						}, 300)
					}
                }
				
				/*
                if ($(this).hasClass('current')) {
                    $(this).removeClass('current')
                    $('.js-grid-item').show()

                } else {
                    $('#js-years .current').removeClass('current')
                    $(this).addClass('current')
    
                    $('.js-grid-item').hide()
                    $('.js-year-' + $(this).data('year')).show()
                }


                
                
				msnry.layout()
				*/
                return false
            })


    }


    function init() {
        $win = $(window)
        $body = $('body')

        isHome = $body.hasClass('page-home')
        isProjectPage = $body.hasClass('page-project')

		/*
		if (isProjectPage && isPhone) {
			$('.item img').each(function() {
				var small = $(this).data('small')
				if (small) $(this).attr('src', small)
			})
		}
		*/
		
		$title = $('#js-title')
		$fixedTitle = $('#js-fixed-title')

        $container = $('#container')
        $wrap = $('#wrap')
		$content = $body
		$sections = $('.years-item')
		$yearnavi = $('#js-year')
		sections = $sections.length

        bindEvents()
        slider()
    }












/*
    
(function( $, undef )
{
	if ( $.fn.dotdotdot )
	{
		return;
	}

	$.fn.dotdotdot = function( o )
	{
		if ( this.length == 0 )
		{
			$.fn.dotdotdot.debug( 'No element found for "' + this.selector + '".' );
			return this;
		}
		if ( this.length > 1 )
		{
			return this.each(
				function()
				{
					$(this).dotdotdot( o );
				}
			);
		}


		var $dot = this;

		if ( $dot.data( 'dotdotdot' ) )
		{
			$dot.trigger( 'destroy.dot' );
		}

		$dot.data( 'dotdotdot-style', $dot.attr( 'style' ) || '' );
		$dot.css( 'word-wrap', 'break-word' );
		if ($dot.css( 'white-space' ) === 'nowrap')
		{
			$dot.css( 'white-space', 'normal' );
		}

		$dot.bind_events = function()
		{
			$dot.bind(
				'update.dot',
				function( e, c )
				{
					e.preventDefault();
					e.stopPropagation();

					opts.maxHeight = ( typeof opts.height == 'number' )
						? opts.height
						: getTrueInnerHeight( $dot );

					opts.maxHeight += opts.tolerance;

					if ( typeof c != 'undefined' )
					{
						if ( typeof c == 'string' || c instanceof HTMLElement )
						{
					 		c = $('<div />').append( c ).contents();
						}
						if ( c instanceof $ )
						{
							orgContent = c;
						}
					}

					$inr = $dot.wrapInner( '<div class="dotdotdot" />' ).children();
					$inr.contents()
						.detach()
						.end()
						.append( orgContent.clone( true ) )
						.find( 'br' )
						.replaceWith( '  <br />  ' )
						.end()
						.css({
							'height'	: 'auto',
							'width'		: 'auto',
							'border'	: 'none',
							'padding'	: 0,
							'margin'	: 0
						});

					var after = false,
						trunc = false;

					if ( conf.afterElement )
					{
						after = conf.afterElement.clone( true );
					    after.show();
						conf.afterElement.detach();
					}

					if ( test( $inr, opts ) )
					{
						if ( opts.wrap == 'children' )
						{
							trunc = children( $inr, opts, after );
						}
						else
						{
							trunc = ellipsis( $inr, $dot, $inr, opts, after );
						}
					}
					$inr.replaceWith( $inr.contents() );
					$inr = null;

					if ( $.isFunction( opts.callback ) )
					{
						opts.callback.call( $dot[ 0 ], trunc, orgContent );
					}

					conf.isTruncated = trunc;
					return trunc;
				}

			).bind(
				'isTruncated.dot',
				function( e, fn )
				{
					e.preventDefault();
					e.stopPropagation();

					if ( typeof fn == 'function' )
					{
						fn.call( $dot[ 0 ], conf.isTruncated );
					}
					return conf.isTruncated;
				}

			).bind(
				'originalContent.dot',
				function( e, fn )
				{
					e.preventDefault();
					e.stopPropagation();

					if ( typeof fn == 'function' )
					{
						fn.call( $dot[ 0 ], orgContent );
					}
					return orgContent;
				}

			).bind(
				'destroy.dot',
				function( e )
				{
					e.preventDefault();
					e.stopPropagation();

					$dot.unwatch()
						.unbind_events()
						.contents()
						.detach()
						.end()
						.append( orgContent )
						.attr( 'style', $dot.data( 'dotdotdot-style' ) || '' )
						.data( 'dotdotdot', false );
				}
			);
			return $dot;
		};	//	/bind_events

		$dot.unbind_events = function()
		{
			$dot.unbind('.dot');
			return $dot;
		};	//	/unbind_events

		$dot.watch = function()
		{
			$dot.unwatch();
			if ( opts.watch == 'window' )
			{
				var $window = $(window),
					_wWidth = $window.width(),
					_wHeight = $window.height();

				$window.bind(
					'resize.dot' + conf.dotId,
					function()
					{
						if ( _wWidth != $window.width() || _wHeight != $window.height() || !opts.windowResizeFix )
						{
							_wWidth = $window.width();
							_wHeight = $window.height();

							if ( watchInt )
							{
								clearInterval( watchInt );
							}
							watchInt = setTimeout(
								function()
								{
									$dot.trigger( 'update.dot' );
								}, 100
							);
						}
					}
				);
			}
			else
			{
				watchOrg = getSizes( $dot );
				watchInt = setInterval(
					function()
					{
						if ( $dot.is( ':visible' ) )
						{
							var watchNew = getSizes( $dot );
							if ( watchOrg.width  != watchNew.width ||
								 watchOrg.height != watchNew.height )
							{
								$dot.trigger( 'update.dot' );
								watchOrg = watchNew;
							}
						}
					}, 500
				);
			}
			return $dot;
		};
		$dot.unwatch = function()
		{
			$(window).unbind( 'resize.dot' + conf.dotId );
			if ( watchInt )
			{
				clearInterval( watchInt );
			}
			return $dot;
		};

		var	orgContent	= $dot.contents(),
			opts 		= $.extend( true, {}, $.fn.dotdotdot.defaults, o ),
			conf		= {},
			watchOrg	= {},
			watchInt	= null,
			$inr		= null;


		if ( !( opts.lastCharacter.remove instanceof Array ) )
		{
			opts.lastCharacter.remove = $.fn.dotdotdot.defaultArrays.lastCharacter.remove;
		}
		if ( !( opts.lastCharacter.noEllipsis instanceof Array ) )
		{
			opts.lastCharacter.noEllipsis = $.fn.dotdotdot.defaultArrays.lastCharacter.noEllipsis;
		}


		conf.afterElement	= getElement( opts.after, $dot );
		conf.isTruncated	= false;
		conf.dotId			= dotId++;


		$dot.data( 'dotdotdot', true )
			.bind_events()
			.trigger( 'update.dot' );

		if ( opts.watch )
		{
			$dot.watch();
		}

		return $dot;
	};


	//	public
	$.fn.dotdotdot.defaults = {
		'ellipsis'			: '... ',
		'wrap'				: 'word',
		'fallbackToLetter'	: true,
		'lastCharacter'		: {},
		'tolerance'			: 0,
		'callback'			: null,
		'after'				: null,
		'height'			: null,
		'watch'				: false,
		'windowResizeFix'	: true
	};
	$.fn.dotdotdot.defaultArrays = {
		'lastCharacter'		: {
			'remove'			: [ ' ', '\u3000', ',', ';', '.', '!', '?' ],
			'noEllipsis'		: []
		}
	};
	$.fn.dotdotdot.debug = function( msg ) {};


	//	private
	var dotId = 1;

	function children( $elem, o, after )
	{
		var $elements 	= $elem.children(),
			isTruncated	= false;

		$elem.empty();

		for ( var a = 0, l = $elements.length; a < l; a++ )
		{
			var $e = $elements.eq( a );
			$elem.append( $e );
			if ( after )
			{
				$elem.append( after );
			}
			if ( test( $elem, o ) )
			{
				$e.remove();
				isTruncated = true;
				break;
			}
			else
			{
				if ( after )
				{
					after.detach();
				}
			}
		}
		return isTruncated;
	}
	function ellipsis( $elem, $d, $i, o, after )
	{
		var isTruncated	= false;

		//	Don't put the ellipsis directly inside these elements
		var notx = 'table, thead, tbody, tfoot, tr, col, colgroup, object, embed, param, ol, ul, dl, blockquote, select, optgroup, option, textarea, script, style';

		//	Don't remove these elements even if they are after the ellipsis
		var noty = 'script, .dotdotdot-keep';

		$elem
			.contents()
			.detach()
			.each(
				function()
				{

					var e	= this,
						$e	= $(e);

					if ( typeof e == 'undefined' || ( e.nodeType == 3 && $.trim( e.data ).length == 0 ) )
					{
						return true;
					}
					else if ( $e.is( noty ) )
					{
						$elem.append( $e );
					}
					else if ( isTruncated )
					{
						return true;
					}
					else
					{
						$elem.append( $e );
						if ( after )
						{
							$elem[ $elem.is( notx ) ? 'after' : 'append' ]( after );
						}
						if ( test( $i, o ) )
						{
							if ( e.nodeType == 3 ) // node is TEXT
							{
								isTruncated = ellipsisElement( $e, $d, $i, o, after );
							}
							else
							{
								isTruncated = ellipsis( $e, $d, $i, o, after );
							}

							if ( !isTruncated )
							{
								$e.detach();
								isTruncated = true;
							}
						}

						if ( !isTruncated )
						{
							if ( after )
							{
								after.detach();
							}
						}
					}
				}
			);

		return isTruncated;
	}
	function ellipsisElement( $e, $d, $i, o, after )
	{
		var e = $e[ 0 ];

		if ( !e )
		{
			return false;
		}

		var txt			= getTextContent( e ),
			space		= ( txt.indexOf(' ') !== -1 ) ? ' ' : '\u3000',
			separator	= ( o.wrap == 'letter' ) ? '' : space,
			textArr		= txt.split( separator ),
			position 	= -1,
			midPos		= -1,
			startPos	= 0,
			endPos		= textArr.length - 1;


		//	Only one word
		if ( o.fallbackToLetter && startPos == 0 && endPos == 0 )
		{
			separator	= '';
			textArr		= txt.split( separator );
			endPos		= textArr.length - 1;
		}

		while ( startPos <= endPos && !( startPos == 0 && endPos == 0 ) )
		{
			var m = Math.floor( ( startPos + endPos ) / 2 );
			if ( m == midPos )
			{
				break;
			}
			midPos = m;

			setTextContent( e, textArr.slice( 0, midPos + 1 ).join( separator ) + o.ellipsis );

			if ( !test( $i, o ) )
			{
				position = midPos;
				startPos = midPos;
			}
			else
			{
				endPos = midPos;

				//	Fallback to letter
				if (o.fallbackToLetter && startPos == 0 && endPos == 0 )
				{
					separator	= '';
					textArr		= textArr[ 0 ].split( separator );
					position	= -1;
					midPos		= -1;
					startPos	= 0;
					endPos		= textArr.length - 1;
				}
			}
		}

		if ( position != -1 && !( textArr.length == 1 && textArr[ 0 ].length == 0 ) )
		{
			txt = addEllipsis( textArr.slice( 0, position + 1 ).join( separator ), o );
			setTextContent( e, txt );
		}
		else
		{
			var $w = $e.parent();
			$e.detach();

			var afterLength = ( after && after.closest($w).length ) ? after.length : 0;

			if ( $w.contents().length > afterLength )
			{
				e = findLastTextNode( $w.contents().eq( -1 - afterLength ), $d );
			}
			else
			{
				e = findLastTextNode( $w, $d, true );
				if ( !afterLength )
				{
					$w.detach();
				}
			}
			if ( e )
			{
				txt = addEllipsis( getTextContent( e ), o );
				setTextContent( e, txt );
				if ( afterLength && after )
				{
					$(e).parent().append( after );
				}
			}
		}

		return true;
	}
	function test( $i, o )
	{
		return $i.innerHeight() > o.maxHeight;
	}
	function addEllipsis( txt, o )
	{
		while( $.inArray( txt.slice( -1 ), o.lastCharacter.remove ) > -1 )
		{
			txt = txt.slice( 0, -1 );
		}
		if ( $.inArray( txt.slice( -1 ), o.lastCharacter.noEllipsis ) < 0 )
		{
			txt += o.ellipsis;
		}
		return txt;
	}
	function getSizes( $d )
	{
		return {
			'width'	: $d.innerWidth(),
			'height': $d.innerHeight()
		};
	}
	function setTextContent( e, content )
	{
		if ( e.innerText )
		{
			e.innerText = content;
		}
		else if ( e.nodeValue )
		{
			e.nodeValue = content;
		}
		else if (e.textContent)
		{
			e.textContent = content;
		}

	}
	function getTextContent( e )
	{
		if ( e.innerText )
		{
			return e.innerText;
		}
		else if ( e.nodeValue )
		{
			return e.nodeValue;
		}
		else if ( e.textContent )
		{
			return e.textContent;
		}
		else
		{
			return "";
		}
	}
	function getPrevNode( n )
	{
		do
		{
			n = n.previousSibling;
		}
		while ( n && n.nodeType !== 1 && n.nodeType !== 3 );

		return n;
	}
	function findLastTextNode( $el, $top, excludeCurrent )
	{
		var e = $el && $el[ 0 ], p;
		if ( e )
		{
			if ( !excludeCurrent )
			{
				if ( e.nodeType === 3 )
				{
					return e;
				}
				if ( $.trim( $el.text() ) )
				{
					return findLastTextNode( $el.contents().last(), $top );
				}
			}
			p = getPrevNode( e );
			while ( !p )
			{
				$el = $el.parent();
				if ( $el.is( $top ) || !$el.length )
				{
					return false;
				}
				p = getPrevNode( $el[0] );
			}
			if ( p )
			{
				return findLastTextNode( $(p), $top );
			}
		}
		return false;
	}
	function getElement( e, $i )
	{
		if ( !e )
		{
			return false;
		}
		if ( typeof e === 'string' )
		{
			e = $(e, $i);
			return ( e.length )
				? e
				: false;
		}
		return !e.jquery
			? false
			: e;
	}
	function getTrueInnerHeight( $el )
	{
		var h = $el.innerHeight(),
			a = [ 'paddingTop', 'paddingBottom' ];

		for ( var z = 0, l = a.length; z < l; z++ )
		{
			var m = parseInt( $el.css( a[ z ] ), 10 );
			if ( isNaN( m ) )
			{
				m = 0;
			}
			h -= m;
		}
		return h;
	}


	//	override jQuery.html
	var _orgHtml = $.fn.html;
	$.fn.html = function( str )
	{
		if ( str != undef && !$.isFunction( str ) && this.data( 'dotdotdot' ) )
		{
			return this.trigger( 'update', [ str ] );
		}
		return _orgHtml.apply( this, arguments );
	};


	//	override jQuery.text
	var _orgText = $.fn.text;
	$.fn.text = function( str )
	{
		if ( str != undef && !$.isFunction( str ) && this.data( 'dotdotdot' ) )
		{
			str = $( '<div />' ).text( str ).html();
			return this.trigger( 'update', [ str ] );
		}
		return _orgText.apply( this, arguments );
	};


})( jQuery );
*/


// WEBPACK FOOTER //
// ./script/main.js